import React from "react";
import Preview from "../menuBoard/preview";
import { CompanyPreviewContainer } from "../../styled/setting";
import TabMenu from "../menuBoard/tabMenu";
import Address from "../menuBoard/addr";
import Details from "../menuBoard/details";

const CompanyPreview = ({
  formData,
  company = null,
  activeTab = 0,
  setActiveTab = null,
  selectCompany,
  visibleMode = "",
}) => {
  return (
    <CompanyPreviewContainer>
      <div className="tit">
        <span>회사 정보 미리보기</span>
      </div>
      <div>
        <Preview company={activeTab === 0 ? formData : company} />
        <TabMenu activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === 0 ? (
          <Address company={formData} />
        ) : (
          <Details company={formData} selectCompany={selectCompany} visibleMode={visibleMode} />
        )}
      </div>
    </CompanyPreviewContainer>
  );
};

export default CompanyPreview;
